import React from 'react';
import './BookDemoButton.css';

const BookDemoButton = () => (
  <div className="book-demo-float">
    <a href="mailto:your-email@example.com?subject=COACHiFY Demo Discussion" className="book-demo-btn">
      📅 Schedule Live Demo
    </a>
  </div>
);

export default BookDemoButton;